// extracted by mini-css-extract-plugin
export default {"container":"i0-z","list":"j0-z"};